import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { logPageView } from "./analytics";

const GAListener = () => {
  const location = useLocation(); // ✅ inside Router now

  useEffect(() => {
    logPageView(location.pathname); // log page view on route change
  }, [location]);

  return null; // renders nothing
};

export default GAListener;
